import { types, Action, State } from '.';
import { Message } from '../../../models/message';
import * as moment from 'moment';

const initialState: State = {
    dirtyDatas: {
        [''] : false
    },
    messageIndicator: new Message()
};

export default function (state: State = initialState, action: Action): State {
    switch (action.type) {
        case types.SET_HAS_DIRTY_DATA:
            return {
                ...state,
                dirtyDatas: {
                    ...state.dirtyDatas,
                    [action.screenName]: action.hasDirtyData
                }
            };

        case types.SET_MESSAGE_INDICATOR: {
            let message = new Message();
            message.id = moment().valueOf();
            message.message = action.message;
            message.type = action.messageType;

            return {
                ...state,
                messageIndicator: message
            };
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/uis/app/reducer.ts